<template>
  <div>
    <button
      class="btn btn-primary"
      :class="margins"
      @click="oeffneMassenmutationsModal"
      v-if="berechtigungen.m_bildung.create"
      :disabled="!editable || isDisabled"
    >
      {{ $t("global.massmutation") }}
    </button>
    <massenmutation-modal-neu
      :customAddition="customAddition"
      :propEntities="propEntities"
      :id="modalId"
      @mutated="mutated"
    >
      <!-- Named slot to pass content to modal -->
      <template #preModalContent v-if="customAddition != null">
        <slot name="preModalContent"></slot>
      </template>
    </massenmutation-modal-neu>
  </div>
</template>
<script>
import MassenmutationModalNeu from "@/components/Modals/MassenmutationModalNeu";

export default {
  name: "MassenmutationButton",
  components: { MassenmutationModalNeu },
  props: {
    selectedIds: {
      type: Array,
    },
    margins: {
      type: String,
      default: "ml-2",
    },
    customAddition: {
      type: null, // not specified
      default: null,
    },
    propEntities: {
      type: Array,
    },
    modalId: {
      type: String,
      default: "massenmutation-modal-neu",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: false,
    };
  },
  watch: {
    selectedIds(val) {
      val != 0 ? (this.editable = true) : (this.editable = false);
    },
  },
  methods: {
    oeffneMassenmutationsModal() {
      if (this.selectedIds.length > 0) {
        this.propEntities[0].selectedIds = this.selectedIds;
        this.$bus.$emit("open-modal", this.modalId);
        this.$bus.$emit("sucheModalOpen");

        // this.selectedIds.forEach((id) => {
        //   let portalinfo = this.listData.find(
        //     (element) => element.id == id
        //   ).portalinfo;

        //   // get id from portalinfo
        // });
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.norecordselected"),
        });
      }
    },
    mutated() {
      this.$emit("mutated");
    },
  },
};
</script>
